import React from 'react';

const outputs = [
  { name: 'Ruby · Reply draft', text: 'Thank you for sharing what made the visit helpful. We’re glad the clear explanation helped you feel comfortable with the next step.' },
  { name: 'Mabel · Article idea', text: 'What to ask before approving a home repair: understanding the problem, the options, and the next step.' },
  { name: 'Annie · Social draft', text: 'A good repair starts with a clear conversation. Before approving the work, ask what caused the problem and what your options are.' },
];

export default function CustomerWordsExample() {
  return (
    <section id="customer-words-example" className="scroll-mt-28 bg-[#101F1F] px-6 py-16 text-white sm:py-20">
      <div className="mx-auto max-w-6xl">
        <p className="font-michroma text-xs uppercase tracking-widest text-[#F6D541]">Illustrative example · fictional review and drafts</p>
        <h2 className="mt-5 max-w-3xl text-3xl font-bold sm:text-5xl">Start with the reason they recommend you.</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-[1.618fr_1fr]">
          <figure className="rounded-3xl border border-white/20 p-7 sm:p-9">
            <figcaption className="text-sm font-bold text-[#F49558]">The customer’s words</figcaption>
            <blockquote className="mt-5 text-2xl leading-relaxed">“They explained the problem in plain English. I finally understood what needed fixing and never felt pressured.”</blockquote>
          </figure>
          <div className="rounded-3xl bg-[#244A49] p-7 sm:p-9">
            <h3 className="text-xl font-bold">The theme worth carrying forward</h3>
            <p className="mt-5 leading-7 text-white/90">Clear explanations help people feel informed and comfortable. Your agency checks that theme against the wider feedback and the business’s actual service.</p>
          </div>
        </div>
        <ol className="mt-6 grid gap-6 lg:grid-cols-3">
          {outputs.map(({ name, text }) => <li key={name} className="rounded-3xl bg-white p-7 text-[#101F1F]"><h3 className="text-lg font-bold text-[#244A49]">{name}</h3><p className="mt-5 leading-7">{text}</p></li>)}
        </ol>
        <p className="mt-7 max-w-4xl text-sm leading-6 text-white/80">These are example drafts, not a customer testimonial or a live product result. Review the source, facts, client voice, and any permissions needed before publishing. One review suggests a topic; repeated feedback helps establish a pattern.</p>
      </div>
    </section>
  );
}